import React from 'react';

// Ortak bilgi modalı — tarayıcının alert() kutusu yerine kullanılır.
const NoticeModal = ({ open, title, message, onClose, danger = false }) => {
    if (!open) return null;
    return (
        <div
            onClick={onClose}
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 3200 }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{ background: 'var(--card-bg, #2d2d2d)', color: 'var(--text-color, #fff)', padding: '28px', borderRadius: '10px', width: '90%', maxWidth: '420px', boxShadow: '0 10px 40px rgba(0,0,0,0.5)', textAlign: 'center' }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '12px', color: danger ? '#dc3545' : 'var(--text-color, #fff)' }}>{title || (danger ? 'Hata' : 'Bilgi')}</h3>
                <p style={{ marginBottom: '24px', lineHeight: 1.5, fontSize: '1.05em' }}>{message}</p>
                <button
                    onClick={onClose}
                    autoFocus
                    style={{ padding: '10px 28px', borderRadius: '6px', border: 'none', cursor: 'pointer', background: danger ? '#dc3545' : '#28a745', color: '#fff', fontWeight: 'bold', fontSize: '1em' }}
                >
                    Tamam
                </button>
            </div>
        </div>
    );
};

export default NoticeModal;
